<template>
  <v-container grid-list-lg>
    <v-row>
      <v-col cols="12">
        <h1 v-if="isNew" mt-10>
          <v-icon left>
            {{ $appConfig.function.icon }}
          </v-icon>
          Function
        </h1>
        <!-- form START -->
        <form>
          <!-- name field START -->
          <v-text-field
            v-model="form.name"
            v-validate="'required|min:3|alpha_dash'"
            label="Name"
            :error-messages="errors.collect('name')"
            data-vv-name="name"
            required
            :disabled="!isNew"
          />
          <!-- name field END -->

          <!-- description field START -->
          <v-textarea
            v-model="form.description"
            v-validate=""
            outlined
            label="Description"
            :error-messages="errors.collect('description')"
            data-vv-name="description"
            rows="2"
          />
          <!-- description field END -->

          <!-- labels START -->
          <hmd-label
            :curr-labels="currLabels"
            :items="isNew ? labels : labelsProp"
            @labels="updateLabels"
          />
          <!-- labels END -->
          <!-- privacy switch START -->
          <v-row align="center">
            <v-col class="mt-4" md="1" cols="2">
              Privacy
            </v-col>
            <v-col class="mt-4" cols="1">
              <v-switch v-model="form.isPrivate" color="primary" />
            </v-col>
            <v-col md="3" cols="5">
              <v-icon
                large
                :color="form.isPrivate ? 'primary' : 'grey'"
                style="margin-top:10px;"
              >
                {{ form.isPrivate ? "mdi-lock" : "mdi-earth" }}
              </v-icon>
              {{ form.isPrivate ? "Private mode" : "Public mode" }}
            </v-col>
            <v-spacer />
          </v-row>
          <!-- privacy switch END -->
          <!-- edit/create buttons START -->
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <v-btn
                :loading="creationLoadingButton"
                :disabled="creationLoadingButton"
                block
                color="secondary"
                large
                @click="submit"
              >
                <v-icon v-if="!isNew" left>
                  mdi-pencil
                </v-icon>
                <v-icon v-else left>
                  mdi-plus
                </v-icon>
                {{ isNew ? "Create function" : "Update function" }}
                <span slot="loader">Creating function...</span>
              </v-btn>
            </v-col>
          </v-row>
          <!-- edit/create buttons END -->

          <!-- delete button START -->
          <template v-if="!isNew">
            <v-col cols="12" class="text-center">
              <v-btn outlined color="blue" large block @click="cloneFunction">
                <v-icon left>
                  mdi-content-duplicate
                </v-icon>
                Clone function
              </v-btn>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn outlined color="error" large block @click="deleteFunction">
                <v-icon left>
                  mdi-delete-outline
                </v-icon>
                Delete function
              </v-btn>
            </v-col>
          </template>
          <!-- delete button END -->
        </form>
        <!-- form END -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from "lodash";
import ProjectService from "./../Projects/services/ProjectService";
import FunctionService from "./services/FunctionService";
import HmdLabel from "../../../UIComponents/HmdLabel.vue";
import HmdService from "../../../UIComponents/services/HmdService";

export default {
  components: {
    HmdLabel
  },
  $_veeValidate: {
    validator: "new"
  },
  props: {
    isNew: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    hmdFunction: {
      type: Object,
      default: function() {
        return {
          time_limit: 60,
          memory_quota: 256
        };
      }
    },
    labelsProp: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      currLabels: [],
      signinDictionary: {
        attributes: {
          email: "E-mail Address"
          // custom attributes
        },
        custom: {
          password: {
            required: () => "Name can not be empty",
            max: "The name field may not be greater than 10 characters"
            // custom messages
          }
        }
      },
      notif: {
        snackbar: false,
        color: "error",
        mode: "",
        timeout: 3000,
        text: ""
      },
      form: {
        items: ["tous", "private"],
        name: String,
        description: String,
        labels: Array,
        isPrivate: true,
        isDashboardFunction: false,
        isSavingDashboardFunction: false
      },
      deleteDialog: false,
      creationLoadingButton: false,
      labels: []
    };
  },
  mounted: function() {
    this.$validator.localize("fr", this.signinDictionary);
    this.form.name = this.hmdFunction.name;
    this.form.description = this.hmdFunction.description;
    this.form.labels = this.hmdFunction.labels;
    if (typeof this.hmdFunction.is_private !== "undefined") {
      this.form.isPrivate = this.hmdFunction.is_private;
    }
    if (this.hmdFunction.is_dashboard_function) {
      this.form.isDashboardFunction = this.hmdFunction.is_dashboard_function;
    }
    if (!this.isNew) {
      var i;
      for (i in this.form.labels) {
        this.currLabels.push(this.form.labels[i].id);
      }
    } else {
      HmdService.label_list().then(result => {
        this.labels = result.data;
      });
    }
  },
  methods: {
    updateLabels(labels) {
      this.form.labels = labels;
    },
    async cloneFunction() {
      const self = this;
      const projects = await ProjectService.list(this).then(r => {
        return _.map(r.data.results, "name");
      });
      this.$store.commit("confirm", {
        message: "Do you really want to clone this function ?",
        title: "Warning",
        color: "warning",
        form: {
          clone_name: {
            type: "text",
            label: "New function name",
            placeholder: "New function's name"
          },
          target_project: {
            type: "select",
            values: projects,
            label: "Target project",
            placeholder: "Choose a target project",
            required: true
          }
        },
        onCancel: () => {},
        onConfirm: args => {
          ProjectService.list(self).then(result => {
            // Retrieve project id
            let myPg = _.pickBy(result.data.results, {
              name: args.target_project
            });
            if (Object.keys(myPg).length > 0) {
              myPg = myPg[Object.keys(myPg)[0]].id;
              FunctionService.clone(
                self.hmdFunction,
                self,
                myPg,
                args.clone_name
              );
            }
          });
        }
      });
    },
    deleteFunction() {
      const self = this;
      this.$store.commit("confirm", {
        message: "Do you really want to delete this function ?",
        title: "Warning",
        color: "warning",
        onCancel: () => {},
        onConfirm: () => {
          FunctionService.delete(self.hmdFunction.id, self).then(() => {
            self.$emit("delete");
          });
        }
      });
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var func = {
            name: this.form.name,
            description: this.form.description,
            labels: this.form.labels,
            is_private: this.form.isPrivate,
            is_global: false,
            project_id: this.$route.params.project || "",
            content: String
          };
          if (this.isNew) {
            func.content = btoa("");
            const t = this;

            // Uncomment the following lines if you want to check first if the function name is already taken.
            // Note : The checking is done during the POST request too, but it could be useful for displaying extra-steps (e.g. displaying dialog for creation as in DatasetCreate)
            // FunctionService.list(this, 0).then(function(response) {
            //   let nameUsed = false

            //   response.data.results.some(elem => {
            //     if (elem.name === t.form.name) {
            //       nameUsed = true
            //       t.errors.add("name", "Function already exists")
            //       t.$store.commit('push', {msg: "Function " + elem.name + " already exists in your database", color: 'error'});
            //       return true
            //     }
            //   })

            //   if (!nameUsed) {
            this.creationLoadingButton = true;
            FunctionService.create(func, t)
              .then(res => {
                this.$emit("create", res.data);
              })
              .finally(() => {
                this.creationLoadingButton = false;
              });
            //   }
            // })
          } else {
            FunctionService.update(func, this);
          }
        }
      });
    },
    handleChangeDashboardFunction: function() {
      this.form.isSavingDashboardFunction = true;

      if (this.form.isDashboardFunction) {
        const func = {
          name: this.form.name
        };
        FunctionService.setFunction(func, this);
      } else {
        FunctionService.unsetFunction(this);
      }
    }
  }
};
</script>
